module.exports = __webpack_public_path__ + "img/btn_icon01.164a2db7.svg";